import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useScannerHelper } from "../../helpers";
import { WorkOrdersParamsTable } from "../../tables";
import { PageContent } from "../../components";

import WorkOrdersBar from "./WorkOrdersBar";
import WorkOrdersToPrint from "./WorkOrdersToPrint";

export const WorkOrdersContent = () => {
  const [workOrder, setWorkOrder] = useState();

  const navigate = useNavigate();

  const onScan = (barcode) => barcode && setWorkOrder(barcode);
  useScannerHelper(onScan, [workOrder]);

  useEffect(() => {
    if (workOrder) navigate(`/works/${workOrder}`);
  }, [workOrder]);

  return (
    <PageContent gap="15px" white smallPadding>
      <WorkOrdersBar />
      <WorkOrdersParamsTable />
      <WorkOrdersToPrint />
    </PageContent>
  );
};

export default WorkOrdersContent;
